const actionTypeIdentifier = 'DD237F36-ED19-4F02-9A89-4246E911792B'

export const getOutputConfigOutputRecords = `GET-OUTPUT-CONFIG-OUTPUT-RECORDS-${actionTypeIdentifier}`;
export const setDefaultConfigOutputRecords = `SET-DEFAULT-CONFIG-OUTPUT-RECORDS-${actionTypeIdentifier}`;
export const setConfigOutputRecordError = `SET-CONFIG-OUTPUT-RECORD-ERROR-${actionTypeIdentifier}`;
export const setConfigOutputRecordColSearchStr = `SET-CONFIG-OUTPUT-RECORD-COLUMN-SEARCH-${actionTypeIdentifier}`;
export const sortConfigOutputRecordItems = `SET-CONFIG-OUTPUT-RECORD-ITEMS-${actionTypeIdentifier}`;
export const setConfigOutputRecordPageSize = `SET-CONFIG-OUTPUT-RECORD-PAGE-SIZE-${actionTypeIdentifier}`;